import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { FormField } from '../../redux/types';
import SelectInputField from '../base/SelectInputField';
import { useTurnOffSaleOptionCallback } from '../hooks';

interface Props {
  className?: string;
}

const OfferDurationSelectField: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const turnOffSaleOption = useTurnOffSaleOptionCallback();
  const { trigger, setValue, watch } = useFormContext();
  const currentValues = watch();

  return (
    <SelectInputField
      className={className}
      name={FormField.Duration}
      label={t('sellerModal.create.duration.label')}
      placeholder={t('sellerModal.create.duration.placeholder')}
      items={[
        { label: t('sellerModal.create.duration.option24Hours'), value: 1 },
        { label: t('sellerModal.create.duration.option48Hours'), value: 2 },
      ]}
      isRequired={currentValues.sell_as_offer}
      onSelect={newValue => {
        newValue && trigger('duration');
        if (newValue) {
          !currentValues.sell_as_offer && setValue(FormField.SellAsOffer, true);
        } else if (!currentValues.offer && currentValues.sell_as_offer) {
          turnOffSaleOption(FormField.SellAsOffer);
        }
      }}
      noBottomSpacing
    />
  );
};

OfferDurationSelectField.displayName = 'OfferDurationSelectField';

export default OfferDurationSelectField;
